import request from '@/utils/request'

// 查询预约分页
export function orderPage(query) {
  return request({
    url: '/manage/bus/order/page',
    method: 'get',
    params: query
  })
}

// 查询后台待确认预约提醒
export function pendingOrderReminder() {
  return request({
    url: '/manage/bus/order/pending-reminder',
    method: 'get'
  })
}

// 查询预约详情
export function getOrderInfo(orderId) {
  return request({
    url: '/manage/bus/order/info/' + orderId,
    method: 'get'
  })
}

// 拒绝预约
export function appointmentOrder(data) {
  return request({
    url: '/manage/bus/order/rejection',
    method: 'PUT',
    data: data
  })
}

// 同意预约
export function approvedOrder(data) {
  return request({
    url: '/manage/bus/order/approved',
    method: 'PUT',
    data: data
  })
}

// 查询公交线路列表
export function routeList() {
  return request({
    url: '/manage/bus/route/list',
    method: 'get'
  })
}

// 查询公交线路列表
export function stationList(routeId) {
  return request({
    url: '/manage/bus/station/list' + "?routeId=" + routeId,
    method: 'get'
  })
}

// 查询预约时间轴
export function timeline(orderId) {
  return request({
    url: '/manage/bus/order-log/timeline/' + orderId,
    method: 'get'
  })
}
